export const WestKowloonStationMapInformation = {
  venue: "WestKowloonStation",
  venueId: "4aafeb4b-a570-45fd-8404-119906425dbd",
  i18nVenue: "venue_west_kowloon_station",
  venueName: "West Kowloon Station",
  venueName_zh: "西九龍站",
  avatar:
    "https://assets.deepworldmodel.ai/navigation/avatar/tchai_20260805_2124.glb",
  avatarIsFloating : false,
  floorAlignment: [
    {
      id: "1af6a37a-ef8e-40ec-be9d-f20cb72e8908",
      lcMapId: "ae538beb-c689-4854-a69b-3389c2b9a5a0",
      name: "B2",
      shortName: "B2",
      ordinal: -4,
      imageUrl:
        "https://locaite-dev.collectiv.co/assets/b0ad84e4-702d-4d7e-923f-aead04391e8f/m2-1785937985964XAFAWA.png",
      pixInMeter: 2.95314946605999,
      center: { lat: 22.304101804899844, lng: 114.1651105327814 },
      angle: 0.0008573154015962814,
      scale: 338.62034314357084,
      corners: {
        tl: { lat: 22.30688824745072, lng: 114.162098756837 },
        tr: { lat: 22.30688824745072, lng: 114.16812230872578 },
        br: { lat: 22.30131536234897, lng: 114.16812230872578 },
        bl: { lat: 22.30131536234897, lng: 114.162098756837 },
      },
      size: { width: 1830, height: 1830 },
      sizeInMeters: { width: 619.6650427589744, height: 619.6774060212555 },
    },
    {
      id: "394f80eb-c61f-4667-a339-2efec90719ca",
      lcMapId: "fa6f118b-6a34-4215-9d9e-fddc61d15955",
      name: "B2M",
      shortName: "B2M",
      ordinal: -3,
      imageUrl:
        "https://locaite-dev.collectiv.co/assets/b0ad84e4-702d-4d7e-923f-aead04391e8f/m3-1785938011502QOQALI.png",
      pixInMeter: 2.95314946605999,
      center: { lat: 22.304101804899844, lng: 114.1651105327814 },
      angle: 0.0008573154015962814,
      scale: 338.62034314357084,
      corners: {
        tl: {
          lat: 22.30688824745072,
          lng: 114.162098756837,
        },
        tr: { lat: 22.30688824745072, lng: 114.16812230872578 },
        br: { lat: 22.30131536234897, lng: 114.16812230872578 },
        bl: { lat: 22.30131536234897, lng: 114.162098756837 },
      },
      size: { width: 1830, height: 1830 },
      sizeInMeters: { width: 619.6650427589744, height: 619.6774060212555 },
    },
    {
      id: "52432522-10f1-4b49-906a-0f262996c687",
      lcMapId: "3be2a750-19a3-4de1-821f-250fda739d76",
      name: "B1",
      shortName: "B1",
      ordinal: -2,
      imageUrl:
        "https://locaite-dev.collectiv.co/assets/b0ad84e4-702d-4d7e-923f-aead04391e8f/m0-1785937936610ZUPEVE.png",
      pixInMeter: 2.95314946605999,
      center: { lat: 22.304101804899844, lng: 114.1651105327814 },
      angle: 0.0008573154015962814,
      scale: 338.62034314357084,
      corners: {
        tl: { lat: 22.30688824745072, lng: 114.162098756837 },
        tr: { lat: 22.30688824745072, lng: 114.16812230872578 },
        br: { lat: 22.30131536234897, lng: 114.16812230872578 },
        bl: { lat: 22.30131536234897, lng: 114.162098756837 },
      },
      size: { width: 1830, height: 1830 },
      sizeInMeters: { width: 619.6650427589744, height: 619.6774060212555 },
    },
    {
      id: "619860b7-f541-408a-babe-073198e5a37f",
      lcMapId: "c2bb496a-ac9f-4150-b245-8cfefb53c452",
      name: "B1M",
      shortName: "B1M",
      ordinal: -1,
      imageUrl:
        "https://locaite-dev.collectiv.co/assets/b0ad84e4-702d-4d7e-923f-aead04391e8f/m1-1785937961409LULANA.png",
      pixInMeter: 2.95314946605999,
      center: { lat: 22.304101804899844, lng: 114.1651105327814 },
      angle: 0.0008573154015962814,
      scale: 338.62034314357084,
      corners: {
        tl: { lat: 22.30688824745072, lng: 114.162098756837 },
        tr: { lat: 22.30688824745072, lng: 114.16812230872578 },
        br: { lat: 22.30131536234897, lng: 114.16812230872578 },
        bl: { lat: 22.30131536234897, lng: 114.162098756837 },
      },
      size: { width: 1830, height: 1830 },
      sizeInMeters: { width: 619.6650427589744, height: 619.6774060212555 },
    },
    {
      id: "491df8a8-54e4-4512-84c3-8318b883be36",
      lcMapId: "c78c079f-c678-4fe4-822a-83b9cf2229fa",
      name: "G",
      shortName: "G",
      ordinal: 0,
      imageUrl:
        "https://locaite-dev.collectiv.co/assets/b0ad84e4-702d-4d7e-923f-aead04391e8f/m4-1785938034452ZUQIDU.png",
      pixInMeter: 2.95314946605999,
      center: { lat: 22.304101804899844, lng: 114.1651105327814 },
      angle: 0.0008573154015962814,
      scale: 338.62034314357084,
      corners: {
        tl: { lat: 22.30688824745072, lng: 114.162098756837 },
        tr: { lat: 22.30688824745072, lng: 114.16812230872578 },
        br: { lat: 22.30131536234897, lng: 114.16812230872578 },
        bl: { lat: 22.30131536234897, lng: 114.162098756837 },
      },
      size: { width: 1830, height: 1830 },
      sizeInMeters: { width: 619.6650427589744, height: 619.6774060212555 },
    },
    {
      id: "a85c68c5-53d2-49bd-99a2-3d444fa93ac5",
      lcMapId: "2a881f74-ac09-4b0b-82d2-40d2e4bc77c1",
      name: "GFM",
      shortName: "GFM",
      ordinal: 1,
      imageUrl:
        "https://locaite-dev.collectiv.co/assets/b0ad84e4-702d-4d7e-923f-aead04391e8f/m5-1785938063561JUYELI.png",
      pixInMeter: 2.95314946605999,
      center: { lat: 22.304101804899844, lng: 114.1651105327814 },
      angle: 0.0008573154015962814,
      scale: 338.62034314357084,
      corners: {
        tl: { lat: 22.30688824745072, lng: 114.162098756837 },
        tr: { lat: 22.30688824745072, lng: 114.16812230872578 },
        br: { lat: 22.30131536234897, lng: 114.16812230872578 },
        bl: { lat: 22.30131536234897, lng: 114.162098756837 },
      },
      size: { width: 1830, height: 1830 },
      sizeInMeters: { width: 619.6650427589744, height: 619.6774060212555 },
    },
    {
      id: "516fb025-cdd4-45d9-b638-a1b53e556301",
      lcMapId: "cef59bc3-66b6-4aa6-a95d-fb2445e57e5e",
      name: "L1",
      shortName: "L1",
      ordinal: 2,
      imageUrl:
        "https://locaite-dev.collectiv.co/assets/b0ad84e4-702d-4d7e-923f-aead04391e8f/m6-1785938081017QUPEDO.png",
      pixInMeter: 2.95314946605999,
      center: { lat: 22.304101804899844, lng: 114.1651105327814 },
      angle: 0.0008573154015962814,
      scale: 338.62034314357084,
      corners: {
        tl: { lat: 22.30688824745072, lng: 114.162098756837 },
        tr: { lat: 22.30688824745072, lng: 114.16812230872578 },
        br: { lat: 22.30131536234897, lng: 114.16812230872578 },
        bl: { lat: 22.30131536234897, lng: 114.162098756837 },
      },
      size: { width: 1830, height: 1830 },
      sizeInMeters: { width: 619.6650427589744, height: 619.6774060212555 },
    },
  ],
  modelConfig: {
    folderPath: "venue/west_kowloon_station/",
    defaultPosition: [-899.49, -13, -882.58],
    defaultTarget: [-898.38, -13, -877.71],
    defaultFloorIndex: -2,
    defaultLcMapId: "3be2a750-19a3-4de1-821f-250fda739d76",
    topAltitude: 210,
    downSpeed: 200,
    scaleFactor: 4.42972419734,
    moveSpeed: 2,
    rotateSpeed: 20,
    splat: {
      mode: "singleLod",
      singleLod: "lod/lod-meta.json",
    },
    floorMesh: "floor_mesh/wksFloor_20260113_1800.glb",
    floorMeshPosition: [-915, 0, -915],
    floor: [
      {
        id: "1af6a37a-ef8e-40ec-be9d-f20cb72e8908",
        lcMapId: "ae538beb-c689-4854-a69b-3389c2b9a5a0",
        index: -4,
        name: "B2",
        shortName: "B2",
        altitude: -34,
        topViewModel: "b2/B2_topView_20260612_0930_16tiles.glb",
        yAxis: -34,
        cameras: [
          [-1099.559, -29.80091, 755.7816],
          [-1050.917, -29.16991, 698.5759],
          [-1149.892, -32.72666, 667.2157],
          [-1092.739, -26.25463, 590.5302],
          [-1031.372, -30.22681, 490.3717],
          [-1105.5, -30.95352, 823.5452],
          [-1149.203, -29.37656, 890.3356],
          [-1177.411, -30.76905, 992.0888],
          [-1159.174, -32.41691, 1100.82],
          [-1178.036, -30.58092, 1184.431],
          [-1195.337, -32.71932, 1242.275],
          [-1163.084, -33.02246, 1269.683],
          [-1192.809, -33.19062, 1351.573],
          [-1180.71, -33.92375, 1401.908],
          [-1198.83, -32.62684, 1484.04],
        ],
        defaultPosition: [-1103.38, -34, -624.41],
        defaultTarget: [-1100.06, -34, -620.66],
      },
      {
        id: "52432522-10f1-4b49-906a-0f262996c687",
        lcMapId: "3be2a750-19a3-4de1-821f-250fda739d76",
        index: -2,
        name: "B1",
        shortName: "B1",
        //sog: "b1/b1_20260108_1730_no_ceiling.sog",
        altitude: -13,
        topViewModel: "b1/B1_topView_20260612_0930_16tiles.glb",
        yAxis: -13,
        cameras: [
          [-1086.069, -11.96336, 699.2535],
          [-1014.693, -6.400549, 721.4101],
          [-960.6052, -5.388933, 826.6296],
          [-865.8367, -8.111762, 775.0499],
          [-928.604, -11.4955, 984.3691],
          [-880.289, -9.976798, 1043.982],
          [-764.5458, -9.44786, 1065.968],
          [-966.2633, -12.48993, 1100.371],
          [-988.1818, -7.453878, 1131.725],
          [-1097.071, -6.954564, 1119.769],
        ],
        defaultPosition: [-899.49, -13, -882.58],
        defaultTarget: [-898.38, -13, -877.71],
      },
      {
        id: "491df8a8-54e4-4512-84c3-8318b883be36",
        lcMapId: "c78c079f-c678-4fe4-822a-83b9cf2229fa",
        index: 0,
        name: "G",
        shortName: "G",
        //sog: "g/g_20260108_1730_no_ceiling.sog",
        altitude: 7,
        topViewModel: "g/G_topView_20260612_0930_16tiles.glb",
        yAxis: 7,
        cameras: [
          [-1099.559, -29.80091, 755.7816],
          [-1103.038, 6.912609, 766.6795],
          [-1108.134, 7.956286, 836.0771],
          [-1158.058, 7.014514, 887.9686],
          [-1176.37, 6.165534, 956.2593],
          [-1186.885, 6.147374, 1018.824],
          [-1162.103, 8.871501, 1055.512],
        ],
        defaultPosition: [-1107.23, 7, -808.57],
        defaultTarget: [-1109.49, 7, -813.03],
      },
      {
        id: "a85c68c5-53d2-49bd-99a2-3d444fa93ac5",
        lcMapId: "2a881f74-ac09-4b0b-82d2-40d2e4bc77c1",
        index: 1,
        name: "GFM",
        shortName: "GFM",
        // sog: "gfm/gfm_20260108_1730_no_ceiling.sog",
        altitude: 8,
        topViewModel: "gfm/GFM_topView_20260612_0930_16tiles.glb",
        yAxis: 8,
        cameras: [
          [-1039.631, 9.290417, 624.3079],
          [-940.8594, 9.015102, 650.8076],
          [-935.3864, 9.038339, 745.2511],
          [-929.6434, 9.971678, 876.5971],
          [-820.9655, 9.522997, 962.4642],
          [-790.3508, 11.263, 1039.302],
          [-698.0084, 10.10951, 1061.088],
        ],
        defaultPosition: [-780.97, 8, -1013.26],
        defaultTarget: [-784.93, 8, -1010.2],
      },
      {
        id: "516fb025-cdd4-45d9-b638-a1b53e556301",
        lcMapId: "cef59bc3-66b6-4aa6-a95d-fb2445e57e5e",
        index: 2,
        name: "L1",
        shortName: "L1",
        //sog: "l1/l1_20260108_1730_no_ceiling.sog",
        altitude: 21,
        topViewModel: "l1/L1_topView_20260612_0930_16tiles.glb",
        yAxis: 21,
        cameras: [
          [-721.0762, 23.35177, 1085.67],
          [-665.3782, 22.92555, 1078.322],
        ],
        defaultPosition: [-694.69, 21, -1111.46],
        defaultTarget: [-695.94, 21, -1106.62],
      },
    ],
  },
};
